import { FieldBase } from '@/components/form/fieldBase';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@e2n/ui';
import { Markierung } from '@/domain/termine/components';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { markierungMapper } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';
import { useKalenderSorting } from '@/domain/termine/shared/utils/useKalenderSorting';

type CalendarSelectSheetProps = {
  kalender: TerminKalender[];
};

type CalendarSelectItemProps = {
  kalenderItem: TerminKalender;
};

function CalendarSelectItem({ kalenderItem }: CalendarSelectItemProps) {
  return (
    <SelectItem className="p-2" value={kalenderItem.id}>
      <div className="flex items-center gap-2">
        {kalenderItem.markierung && (
          <Markierung color={markierungMapper[kalenderItem.markierung].base} />
        )}
        <span className="text-sm font-medium">{kalenderItem.name}</span>
      </div>
    </SelectItem>
  );
}

export function CalendarSelectSheet({ kalender }: CalendarSelectSheetProps) {
  const { form } = useCreateTermineFormContext();
  const { t } = useTranslation();

  const sortKalender = useKalenderSorting(kalender);
  return (
    <div>
      <form.AppField name="terminKalenderId">
        {(field) => {
          const selectedKalender = sortKalender.find(
            (k) => k.id === field.state.value,
          );
          const displayText = selectedKalender?.name;
          return (
            <FieldBase label={t('domain.termine.terminCalendar')}>
              <Select
                value={field.state.value}
                onValueChange={field.handleChange}>
                <SelectTrigger
                  className="border-neutrals-300 w-full"
                  onBlur={field.handleBlur}>
                  <div className="flex items-center gap-2">
                    {selectedKalender?.markierung && (
                      <Markierung
                        color={
                          markierungMapper[selectedKalender.markierung].base
                        }
                      />
                    )}
                    <span>{displayText}</span>
                  </div>
                </SelectTrigger>
                <SelectContent className="border-none overflow-visible">
                  <SelectGroup>
                    {sortKalender.map((kalenderItem) => (
                      <CalendarSelectItem
                        key={kalenderItem.id}
                        kalenderItem={kalenderItem}
                      />
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </FieldBase>
          );
        }}
      </form.AppField>
    </div>
  );
}
